import { ANIMATION_DURATION } from './constants';

export const deliveryMixin = {
	methods: {
		resetCalculation()
		{
			this.price = 0;
			this.distance = 0;
			this.address = '';
			this.deliveryType = null;
			this.warehouseCode = null;
			this.errors = [];
			this.hasCalculated = false;
			this.isCalculating = false;

			if (this.params.showInitialPrice)
			{
				this.price = Math.max(Number(this.params.startPrice) || 0, 0);
			}
			this.animatedPrice = this.price;
		},

		onBeforeCalculate()
		{
			// In MODAL mode the page reflects a delivery only after the user
			// confirms (onAfterApplyPrice); live map calculations must not
			// change the page state — that belongs to PAGE mode only.
			if (this.isModal)
			{
				return;
			}

			this.isCalculating = true;
			this.errors = [];
		},

		onAfterCalculate({ deliveryData })
		{
			if (this.isModal)
			{
				return;
			}

			this.isCalculating = false;
			this.hasCalculated = true;

			this.extractDeliveryMeta(deliveryData);
			this.setTotalData(deliveryData);
		},

		onAfterApplyPrice(calculateProps)
		{
			this.isCalculating = false;
			this.hasCalculated = true;

			this.extractDeliveryMeta(calculateProps);
			this.setTotalData(calculateProps);
		},

		extractDeliveryMeta(delivery)
		{
			this.deliveryType = delivery?.type || null;
			this.warehouseCode = delivery?.warehouseCode || null;

			const rawErrors = delivery?.errors?.errors;
			if (Array.isArray(rawErrors) && rawErrors.length > 0)
			{
				this.errors = rawErrors.map((err) => err.message || err.code || String(err));
			}
			else
			{
				this.errors = [];
			}
		},

		setTotalData(delivery)
		{
			const oldPrice = this.price;
			this.price = delivery?.price ?? 0;
			this.address = delivery?.address || '';
			this.distance = delivery?.distance || 0;

			if (oldPrice !== this.price)
			{
				this.animatePrice(this.animatedPrice, this.price);
			}
		},

		animatePrice(from, to)
		{
			if (this.animationFrameId)
			{
				cancelAnimationFrame(this.animationFrameId);
				this.animationFrameId = null;
			}

			if (to < 0)
			{
				this.animatedPrice = to;
				return;
			}

			const startTime = performance.now();
			const diff = to - from;

			const step = (currentTime) =>
			{
				const elapsed = currentTime - startTime;
				const progress = Math.min(elapsed / ANIMATION_DURATION, 1);
				const eased = 1 - Math.pow(1 - progress, 3);

				this.animatedPrice = Math.round(from + diff * eased);

				if (progress < 1)
				{
					this.animationFrameId = requestAnimationFrame(step);
				}
				else
				{
					this.animatedPrice = to;
					this.animationFrameId = null;
				}
			};

			this.animationFrameId = requestAnimationFrame(step);
		},

		onOrderPriceChange()
		{
			const value = Number(this.orderPrice);
			if (value > 0)
			{
				this.total.price = value;
				this.setTotalResult();
				this.recalculateAddress();
			}
		},

		onOrderWeightChange()
		{
			const value = Number(this.orderWeight);
			if (value > 0)
			{
				this.total.weight = value * this.weightToGramsMultiplier;
				this.setTotalResult();
				this.recalculateAddress();
			}
		},

		recalculateAddress()
		{
			if (this.address && this.api)
			{
				this.api.calculateRoute(this.address);
			}
		},

		setTotalResult()
		{
			this.api?.setResult({ TOTAL: this.total });
		},
	},
};
